import {
  DeleteAgreementDocumenteMutation,
  DeleteAgreementDocumenteMutationVariables,
} from "@/gql/graphql";
import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const mutation = gql`
  mutation DeleteAgreementDocumente($documentId: ID!, $customerNumber: Int!) {
    productPrice {
      agreementDocuments {
        deleteAgreementDocument(
          documentId: $documentId
          customerNumber: $customerNumber
        ) {
          __typename
          ... on DeleteAgreementDocumentErrorResult {
            errors {
              message
              path
            }
          }
          ... on DeleteAgreementDocumentSuccessResult {
            success
          }
        }
      }
    }
  }
`;

export const useDeleteAgreementDocumentMutation = () => {
  const [mutate, { loading }] = useMutation<
    DeleteAgreementDocumenteMutation,
    DeleteAgreementDocumenteMutationVariables
  >(mutation);
  const deleteAgreementDocument = useCallback(
    (customerNumber: number, documentId: string) => {
      return mutate({
        variables: {
          customerNumber,
          documentId,
        },
      });
    },
    [mutate]
  );
  return {
    deleteAgreementDocument,
    loading,
  };
};
